import axios from 'axios'
import store from '../store';
import router from '../router'

const api_instance = axios.create({
  baseURL: getUrl(),
  timeout: 60000,
  withCredentials: true
})

const requestInterceptor = config => {
  // Attach proper csrf token to header
  if(['post', 'put', 'patch', 'delete'].includes(config.method)) {
    const csrfToken = localStorage.getItem('g2_communicator_csrf_access_token')
    config.headers['X-CSRF-TOKEN'] = csrfToken
  }
  return config
}

const responseSuccessInterceptor = (response) => {
  // Set csrf tokens upon successful response to '/authenticate'
  if(response.config.url.includes('authenticate')) {
    localStorage.setItem('g2_communicator_csrf_access_token', response.data.csrf_access_token)
  }

  return response
}


const responseErrorInterceptor = (error) => {
  const response = error.response

  if(!response || response.status !== 401) {
    return Promise.reject(error)
  }

  store.commit('LOGOUT')
  router.push({ name: 'Login' })
}


api_instance.interceptors.request.use(requestInterceptor)

api_instance.interceptors.response.use(responseSuccessInterceptor, responseErrorInterceptor)

export const instance = api_instance

// Get the base url for the API based on production or development.
function getUrl () {
  // CBTODO -- This will be different in the dev environment. Can we make this easier across environments?
  if (process.env.NODE_ENV === 'development') 
    return 'http://localhost:5000'
  return location.origin + '/api'
}
